/**
 * Errors defined in this file are used by the error boundary to route errors the handling pages
 * Error instances should expose the following interface:
 *
 * - `routeMap` is an object which maps errors to pages which can handle those errors
 * - `graphqlErrors` is an array of strings which are the specific set of named errors
 *  - TODO: think about non-graphql related errors
 * - `name` should match class name the group of errors the error represents, e.g. the name of the error enum
 */
export class BookOrderError extends Error {
  // this is the map of files
  routeMap = {
    // "Seat is unavailable for purchase, probably has been booked by someone else"
    SEAT_UNAVAILABLE: 'seats',
    // "A traveler on your booking requires Special Assistance. This affects which seats the travelers on the booking can purchase on the plane..."
    SEAT_SSR_RESTRICTION: 'seats',
    // "A fare update occurred while you were shopping which affected the flights in your cart"
    FARES_CHANGED: 'flights',
    // "A flight you selected is no longer available."
    FLIGHT_UNAVAILABLE: 'flights',
    // "The hotel room option you chose is no longer available. Please choose an alternative hotel option."
    ROOM_UNAVAILABLE: 'hotels',
    // "The hotel package price you chose is no longer available. Please choose an alternative hotel option."
    HOTEL_PRICE_CHANGED: 'hotels',
    // "Hotel service is currently unavailable. Please try again later."
    HOTEL_UNAVAILABLE: 'hotels',
    // "A Bundle you selected is no longer available. Please click below and choose your bundle again. We apologize for any inconvenience."
    BUNDLE_UNAVAILABLE: 'bundles',
    // "It looks like you didn't complete your included bundled seat selections for all passengers or all flights."
    BUNDLE_SEAT_VIOLATION: 'seats',
    // "It looks like you didn't complete your included bundled bag or extra selections for all passengers or all flights."
    BUNDLE_ANCILLARY_VIOLATION: 'bags',
    // "The vehicle you chose is no longer available for the selected period. Please choose an alternate vehicle option."
    VEHICLE_UNAVAILABLE: 'flights',
    // "Ticket is unavailable for purchase, probably has been booked by someone else"
    SHOW_SEATS_UNAVAILABLE: 'tickets',
    // "Show is unavailable for booking"
    SHOW_UNAVAILABLE: 'tickets',
  };
  name = 'BookOrderError';

  constructor(graphqlErrors) {
    super(
      `An error when the user attempted to purchase the order: ${graphqlErrors}`
    );

    this.graphqlErrors = graphqlErrors || [];
  }
}

export class NoTransactionIdError extends Error {
  routeMap = {};

  name = 'NoTransactionIdError';

  constructor() {
    super('No order!');

    this.graphqlErrors = ['NO_TRANSACTION_ID'];
  }
}
